import { render } from "./DashboardManageAccessPetitionsView.vue?vue&type=template&id=5c4dffb6"
import script from "./DashboardManageAccessPetitionsView.vue?vue&type=script&lang=js"
export * from "./DashboardManageAccessPetitionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__